import React from 'react';

export function LoadingSpinner({ isDark = false }: { isDark?: boolean }) {
  const color = isDark ? 'white' : 'black';
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-transparent pointer-events-none z-0">
      <div 
        className="w-10 h-10 rounded-full animate-spin"
        style={{
          background: `conic-gradient(from 0deg, transparent 0%, transparent 20%, ${color} 100%)`,
          WebkitMaskImage: 'radial-gradient(farthest-side, transparent calc(100% - 4px), white calc(100% - 3px))',
          maskImage: 'radial-gradient(farthest-side, transparent calc(100% - 4px), white calc(100% - 3px))',
          animationDuration: '0.6s'
        }}
      />
    </div>
  );
}
